import { ReactComponent as AlertSvg } from '../../../../assets/icons/Alert.svg';

import { createIconComponent } from './createIconComponent';

export const AlertIcon = createIconComponent(AlertSvg);
